
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bbsGj", function(module, exports) {

$parcel$export(module.exports, "setRequestState", () => $6627d5885928a42a$export$5590937a2c44af77);
$parcel$export(module.exports, "generateLibraryState", () => $6627d5885928a42a$export$4d657b11f5678790);
$parcel$export(module.exports, "parseRequestState", () => $6627d5885928a42a$export$803567147421ddac);
/*! @azure/msal-common v16.5.2 2026-04-28 */ 
var $9C5X5 = parcelRequire("9C5X5");

var $irvad = parcelRequire("irvad");

var $ks9Dx = parcelRequire("ks9Dx");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Appends user state with random guid, or returns random guid.
 * @param cryptoObj
 * @param userState
 * @param meta
 */ function $6627d5885928a42a$export$5590937a2c44af77(cryptoObj, userState, meta) {
    const libraryState = $6627d5885928a42a$export$4d657b11f5678790(cryptoObj, meta);
    return userState ? `${libraryState}${0, $9C5X5.RESOURCE_DELIM}${userState}` : libraryState;
}
/**
 * Generates the state value used by the common library.
 * @param cryptoObj
 * @param meta
 */ function $6627d5885928a42a$export$4d657b11f5678790(cryptoObj, meta) {
    if (!cryptoObj) throw (0, $irvad.createClientAuthError)((0, $ks9Dx.noCryptoObject));
    // Create a state object containing a unique id and the timestamp of the request creation
    const stateObj = {
        id: cryptoObj.createNewGuid()
    };
    if (meta) stateObj.meta = meta;
    const stateString = JSON.stringify(stateObj);
    return cryptoObj.base64Encode(stateString);
}
/**
 * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
 * @param base64Decode
 * @param state
 */ function $6627d5885928a42a$export$803567147421ddac(base64Decode, state) {
    if (!base64Decode) throw (0, $irvad.createClientAuthError)((0, $ks9Dx.noCryptoObject));
    if (!state) throw (0, $irvad.createClientAuthError)((0, $ks9Dx.invalidState));
    try {
        // Split the state between library state and user passed state and decode them separately
        const splitState = state.split((0, $9C5X5.RESOURCE_DELIM));
        const libraryState = splitState[0];
        const userState = splitState.length > 1 ? splitState.slice(1).join((0, $9C5X5.RESOURCE_DELIM)) : "";
        const libraryStateString = base64Decode(libraryState);
        const libraryStateObj = JSON.parse(libraryStateString);
        return {
            userRequestState: userState || "",
            libraryState: libraryStateObj
        };
    } catch (e) {
        throw (0, $irvad.createClientAuthError)((0, $ks9Dx.invalidState));
    }
}

});
parcelRegister("9C5X5", function(module, exports) {

$parcel$export(module.exports, "SKU", () => $24168bfc9e232f27$export$45c909820884b9ec);
$parcel$export(module.exports, "DEFAULT_AUTHORITY", () => $24168bfc9e232f27$export$405127a8c597bdfe);
$parcel$export(module.exports, "DEFAULT_AUTHORITY_HOST", () => $24168bfc9e232f27$export$ff29228a41d88890);
$parcel$export(module.exports, "DEFAULT_COMMON_TENANT", () => $24168bfc9e232f27$export$cf84b28865aad146);
$parcel$export(module.exports, "ADFS", () => $24168bfc9e232f27$export$d67d0b9d84b9fa64);
$parcel$export(module.exports, "DSTS", () => $24168bfc9e232f27$export$ed356007bd76ccea);
$parcel$export(module.exports, "AAD_INSTANCE_DISCOVERY_ENDPT", () => $24168bfc9e232f27$export$e56648d3c1473424);
$parcel$export(module.exports, "CIAM_AUTH_URL", () => $24168bfc9e232f27$export$ecbbba19d57055cd);
$parcel$export(module.exports, "AAD_TENANT_DOMAIN_SUFFIX", () => $24168bfc9e232f27$export$8a15b376f6b2940);
$parcel$export(module.exports, "RESOURCE_DELIM", () => $24168bfc9e232f27$export$c49b7e87df554b81);
$parcel$export(module.exports, "CONSUMER_UTID", () => $24168bfc9e232f27$export$90fa201058ba044f);
$parcel$export(module.exports, "OPENID_SCOPE", () => $24168bfc9e232f27$export$74fa595b48c8c01e);
$parcel$export(module.exports, "PROFILE_SCOPE", () => $24168bfc9e232f27$export$76ff9ac69ea41312);
$parcel$export(module.exports, "OFFLINE_ACCESS_SCOPE", () => $24168bfc9e232f27$export$b281676656f67eb4);
$parcel$export(module.exports, "EMAIL_SCOPE", () => $24168bfc9e232f27$export$a69a793fa9a71a6f);
$parcel$export(module.exports, "CODE_GRANT_TYPE", () => $24168bfc9e232f27$export$69cccd63344f058d);
$parcel$export(module.exports, "S256_CODE_CHALLENGE_METHOD", () => $24168bfc9e232f27$export$c12418ff35a420f6);
$parcel$export(module.exports, "URL_FORM_CONTENT_TYPE", () => $24168bfc9e232f27$export$7558dcec6f2048d);
$parcel$export(module.exports, "AUTHORIZATION_PENDING", () => $24168bfc9e232f27$export$b18f0664a2d39502);
$parcel$export(module.exports, "NOT_APPLICABLE", () => $24168bfc9e232f27$export$e8958a6508ec5b71);
$parcel$export(module.exports, "NOT_AVAILABLE", () => $24168bfc9e232f27$export$d5f291b4be36f605);
$parcel$export(module.exports, "FORWARD_SLASH", () => $24168bfc9e232f27$export$933cdf3ebd8cc149);
$parcel$export(module.exports, "IMDS_ENDPOINT", () => $24168bfc9e232f27$export$5eeea8c9d02ceb62);
$parcel$export(module.exports, "IMDS_VERSION", () => $24168bfc9e232f27$export$69aaeb41e2826c48);
$parcel$export(module.exports, "IMDS_TIMEOUT", () => $24168bfc9e232f27$export$7c61cea10ff91469);
$parcel$export(module.exports, "AZURE_REGION_AUTO_DISCOVER_FLAG", () => $24168bfc9e232f27$export$243dfbda037eb091);
$parcel$export(module.exports, "REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX", () => $24168bfc9e232f27$export$b85ac6323a66047);
$parcel$export(module.exports, "KNOWN_PUBLIC_CLOUDS", () => $24168bfc9e232f27$export$afcb83a97360adbc);
$parcel$export(module.exports, "SHR_NONCE_VALIDITY", () => $24168bfc9e232f27$export$20eec6ef8175441);
$parcel$export(module.exports, "INVALID_INSTANCE", () => $24168bfc9e232f27$export$1d8570e3a324589e);
$parcel$export(module.exports, "HTTP_SUCCESS", () => $24168bfc9e232f27$export$f7faf416d920fff3);
$parcel$export(module.exports, "HTTP_SUCCESS_RANGE_START", () => $24168bfc9e232f27$export$bf64241e0c309627);
$parcel$export(module.exports, "HTTP_SUCCESS_RANGE_END", () => $24168bfc9e232f27$export$bb61c9fb50e57838);
$parcel$export(module.exports, "HTTP_REDIRECT", () => $24168bfc9e232f27$export$a704168478db6ad0);
$parcel$export(module.exports, "HTTP_CLIENT_ERROR", () => $24168bfc9e232f27$export$365529322ade2a43);
$parcel$export(module.exports, "HTTP_CLIENT_ERROR_RANGE_START", () => $24168bfc9e232f27$export$6f402514545f3f58);
$parcel$export(module.exports, "HTTP_BAD_REQUEST", () => $24168bfc9e232f27$export$9a0aba463f6ac337);
$parcel$export(module.exports, "HTTP_UNAUTHORIZED", () => $24168bfc9e232f27$export$adbf103f5d371692);
$parcel$export(module.exports, "HTTP_NOT_FOUND", () => $24168bfc9e232f27$export$6226897062245741);
$parcel$export(module.exports, "HTTP_REQUEST_TIMEOUT", () => $24168bfc9e232f27$export$304f7f334b3888b0);
$parcel$export(module.exports, "HTTP_GONE", () => $24168bfc9e232f27$export$73cba17c10a00d41);
$parcel$export(module.exports, "HTTP_TOO_MANY_REQUESTS", () => $24168bfc9e232f27$export$bc275033437a2e03);
$parcel$export(module.exports, "HTTP_CLIENT_ERROR_RANGE_END", () => $24168bfc9e232f27$export$80be1ba03533fcfc);
$parcel$export(module.exports, "HTTP_SERVER_ERROR", () => $24168bfc9e232f27$export$ec31e119ef282c60);
$parcel$export(module.exports, "HTTP_SERVER_ERROR_RANGE_START", () => $24168bfc9e232f27$export$310d0488bddd36e1);
$parcel$export(module.exports, "HTTP_SERVICE_UNAVAILABLE", () => $24168bfc9e232f27$export$b18794ec8d78bd2f);
$parcel$export(module.exports, "HTTP_GATEWAY_TIMEOUT", () => $24168bfc9e232f27$export$d53e5bd3ec9a0f2a);
$parcel$export(module.exports, "HTTP_SERVER_ERROR_RANGE_END", () => $24168bfc9e232f27$export$cabebb7af2e4f2f0);
$parcel$export(module.exports, "HTTP_MULTI_SIDED_ERROR", () => $24168bfc9e232f27$export$910bb73d987bdc9);
$parcel$export(module.exports, "HttpMethod", () => $24168bfc9e232f27$export$8343e6f32f5246de);
$parcel$export(module.exports, "OIDC_DEFAULT_SCOPES", () => $24168bfc9e232f27$export$893b1b5b686d84ef);
$parcel$export(module.exports, "OIDC_SCOPES", () => $24168bfc9e232f27$export$268e88275f5afab2);
$parcel$export(module.exports, "HeaderNames", () => $24168bfc9e232f27$export$28d77f87efed1d88);
$parcel$export(module.exports, "PersistentCacheKeys", () => $24168bfc9e232f27$export$81ab9ba9bd28255c);
$parcel$export(module.exports, "AADAuthority", () => $24168bfc9e232f27$export$3fd50d6e6941567f);
$parcel$export(module.exports, "ClaimsRequestKeys", () => $24168bfc9e232f27$export$c125cda26c71ef54);
$parcel$export(module.exports, "PromptValue", () => $24168bfc9e232f27$export$49a06cbda5acaa5);
$parcel$export(module.exports, "CodeChallengeMethodValues", () => $24168bfc9e232f27$export$a1fe36237c1cc863);
$parcel$export(module.exports, "OAuthResponseType", () => $24168bfc9e232f27$export$5ef2b2ebd3da3e04);
$parcel$export(module.exports, "ResponseMode", () => $24168bfc9e232f27$export$f990a5bae1260b8c);
$parcel$export(module.exports, "GrantType", () => $24168bfc9e232f27$export$ce68f19b50b39c0b);
$parcel$export(module.exports, "CACHE_ACCOUNT_TYPE_MSSTS", () => $24168bfc9e232f27$export$5a1fc3a8d23f6b21);
$parcel$export(module.exports, "CACHE_ACCOUNT_TYPE_ADFS", () => $24168bfc9e232f27$export$8fb8b1752739f076);
$parcel$export(module.exports, "CACHE_ACCOUNT_TYPE_MSAV1", () => $24168bfc9e232f27$export$9e5e568c23c195ce);
$parcel$export(module.exports, "CACHE_ACCOUNT_TYPE_GENERIC", () => $24168bfc9e232f27$export$2825edabe103d5);
$parcel$export(module.exports, "CACHE_KEY_SEPARATOR", () => $24168bfc9e232f27$export$9e9532f57bbb139e);
$parcel$export(module.exports, "CLIENT_INFO_SEPARATOR", () => $24168bfc9e232f27$export$2e94b6c6dd44699e);
$parcel$export(module.exports, "CredentialType", () => $24168bfc9e232f27$export$eca2dc7e6e608a68);
$parcel$export(module.exports, "CacheType", () => $24168bfc9e232f27$export$ba193b555633db78);
$parcel$export(module.exports, "APP_METADATA", () => $24168bfc9e232f27$export$7e1bea6dc1b6b32e);
$parcel$export(module.exports, "CLIENT_INFO", () => $24168bfc9e232f27$export$476989d62bcb4c85);
$parcel$export(module.exports, "THE_FAMILY_ID", () => $24168bfc9e232f27$export$978fe7ab5e74b539);
$parcel$export(module.exports, "AUTHORITY_METADATA_CACHE_KEY", () => $24168bfc9e232f27$export$1137b2d06fad26eb);
$parcel$export(module.exports, "AUTHORITY_METADATA_REFRESH_TIME_SECONDS", () => $24168bfc9e232f27$export$eea04158dccf5d70);
$parcel$export(module.exports, "AuthorityMetadataSource", () => $24168bfc9e232f27$export$5d365d77acfcb55d);
$parcel$export(module.exports, "SERVER_TELEM_SCHEMA_VERSION", () => $24168bfc9e232f27$export$ada8c967fb9297cd);
$parcel$export(module.exports, "SERVER_TELEM_MAX_CUR_HEADER_BYTES", () => $24168bfc9e232f27$export$3ab7d699ccf481db);
$parcel$export(module.exports, "SERVER_TELEM_MAX_LAST_HEADER_BYTES", () => $24168bfc9e232f27$export$166696a6bac48dc5);
$parcel$export(module.exports, "SERVER_TELEM_MAX_CACHED_ERRORS", () => $24168bfc9e232f27$export$6fa374559f78ca9f);
$parcel$export(module.exports, "SERVER_TELEM_CACHE_KEY", () => $24168bfc9e232f27$export$788940e4cd6c0eba);
$parcel$export(module.exports, "SERVER_TELEM_CATEGORY_SEPARATOR", () => $24168bfc9e232f27$export$f51f7d493a85471e);
$parcel$export(module.exports, "SERVER_TELEM_VALUE_SEPARATOR", () => $24168bfc9e232f27$export$b0781166f23da624);
$parcel$export(module.exports, "SERVER_TELEM_OVERFLOW_TRUE", () => $24168bfc9e232f27$export$1ee554efbc503c65);
$parcel$export(module.exports, "SERVER_TELEM_OVERFLOW_FALSE", () => $24168bfc9e232f27$export$aad3ca432a8e0485);
$parcel$export(module.exports, "SERVER_TELEM_UNKNOWN_ERROR", () => $24168bfc9e232f27$export$b3ede2149169f35e);
$parcel$export(module.exports, "AuthenticationScheme", () => $24168bfc9e232f27$export$901491a717da2ba5);
$parcel$export(module.exports, "DEFAULT_THROTTLE_TIME_SECONDS", () => $24168bfc9e232f27$export$c79860cd1fb326bc);
$parcel$export(module.exports, "DEFAULT_MAX_THROTTLE_TIME_SECONDS", () => $24168bfc9e232f27$export$ed50f84f656b8a71);
$parcel$export(module.exports, "THROTTLING_PREFIX", () => $24168bfc9e232f27$export$2c4d2738c7e2e621);
$parcel$export(module.exports, "X_MS_LIB_CAPABILITY_VALUE", () => $24168bfc9e232f27$export$796cc5ec53357060);
$parcel$export(module.exports, "INVALID_GRANT_ERROR", () => $24168bfc9e232f27$export$885686d5cda1602e);
$parcel$export(module.exports, "CLIENT_MISMATCH_ERROR", () => $24168bfc9e232f27$export$5c3e811110c23b4b);
$parcel$export(module.exports, "PasswordGrantConstants", () => $24168bfc9e232f27$export$fa8b29062cab1da);
$parcel$export(module.exports, "RegionDiscoverySources", () => $24168bfc9e232f27$export$3d4a3e11df589b40);
$parcel$export(module.exports, "RegionDiscoveryOutcomes", () => $24168bfc9e232f27$export$92a685f9218422bd);
$parcel$export(module.exports, "CacheOutcome", () => $24168bfc9e232f27$export$aa4af185ea049f6b);
$parcel$export(module.exports, "JsonWebTokenTypes", () => $24168bfc9e232f27$export$fe5c42ed17efe603);
$parcel$export(module.exports, "ONE_DAY_IN_MS", () => $24168bfc9e232f27$export$14c29d43b22a755f);
$parcel$export(module.exports, "DEFAULT_TOKEN_RENEWAL_OFFSET_SEC", () => $24168bfc9e232f27$export$8d50f42618161d1a);
$parcel$export(module.exports, "EncodingTypes", () => $24168bfc9e232f27$export$6592cb873eed5846);
/*! @azure/msal-common v16.5.2 2026-04-28 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $24168bfc9e232f27$export$45c909820884b9ec = "msal.js.common";
// default authority
const $24168bfc9e232f27$export$405127a8c597bdfe = "https://login.microsoftonline.com/common/";
const $24168bfc9e232f27$export$ff29228a41d88890 = "login.microsoftonline.com";
const $24168bfc9e232f27$export$cf84b28865aad146 = "common";
// ADFS String
const $24168bfc9e232f27$export$d67d0b9d84b9fa64 = "adfs";
const $24168bfc9e232f27$export$ed356007bd76ccea = "dstsv2";
// Default AAD Instance Discovery Endpoint
const $24168bfc9e232f27$export$e56648d3c1473424 = `${$24168bfc9e232f27$export$405127a8c597bdfe}discovery/instance?api-version=1.1&authorization_endpoint=`;
// CIAM URL
const $24168bfc9e232f27$export$ecbbba19d57055cd = ".ciamlogin.com";
const $24168bfc9e232f27$export$8a15b376f6b2940 = ".onmicrosoft.com";
// Resource delimiter - used for certain cache entries
const $24168bfc9e232f27$export$c49b7e87df554b81 = "|";
// Consumer UTID
const $24168bfc9e232f27$export$90fa201058ba044f = "9188040d-6c67-4c5b-b112-36a304b66dad";
// Default scopes
const $24168bfc9e232f27$export$74fa595b48c8c01e = "openid";
const $24168bfc9e232f27$export$76ff9ac69ea41312 = "profile";
const $24168bfc9e232f27$export$b281676656f67eb4 = "offline_access";
const $24168bfc9e232f27$export$a69a793fa9a71a6f = "email";
const $24168bfc9e232f27$export$69cccd63344f058d = "authorization_code";
const $24168bfc9e232f27$export$c12418ff35a420f6 = "S256";
const $24168bfc9e232f27$export$7558dcec6f2048d = "application/x-www-form-urlencoded;charset=utf-8";
const $24168bfc9e232f27$export$b18f0664a2d39502 = "authorization_pending";
const $24168bfc9e232f27$export$e8958a6508ec5b71 = "N/A";
const $24168bfc9e232f27$export$d5f291b4be36f605 = "Not Available";
const $24168bfc9e232f27$export$933cdf3ebd8cc149 = "/";
const $24168bfc9e232f27$export$5eeea8c9d02ceb62 = "http://169.254.169.254/metadata/instance/compute/location";
const $24168bfc9e232f27$export$69aaeb41e2826c48 = "2020-06-01";
const $24168bfc9e232f27$export$7c61cea10ff91469 = 2000;
const $24168bfc9e232f27$export$243dfbda037eb091 = "TryAutoDetect";
const $24168bfc9e232f27$export$b85ac6323a66047 = "login.microsoft.com";
const $24168bfc9e232f27$export$afcb83a97360adbc = [
    "login.microsoftonline.com",
    "login.windows.net",
    "login.microsoft.com",
    "sts.windows.net"
];
const $24168bfc9e232f27$export$20eec6ef8175441 = 240;
const $24168bfc9e232f27$export$1d8570e3a324589e = "invalid_instance";
const $24168bfc9e232f27$export$f7faf416d920fff3 = 200;
const $24168bfc9e232f27$export$bf64241e0c309627 = 200;
const $24168bfc9e232f27$export$bb61c9fb50e57838 = 299;
const $24168bfc9e232f27$export$a704168478db6ad0 = 302;
const $24168bfc9e232f27$export$365529322ade2a43 = 400;
const $24168bfc9e232f27$export$6f402514545f3f58 = 400;
const $24168bfc9e232f27$export$9a0aba463f6ac337 = 400;
const $24168bfc9e232f27$export$adbf103f5d371692 = 401;
const $24168bfc9e232f27$export$6226897062245741 = 404;
const $24168bfc9e232f27$export$304f7f334b3888b0 = 408;
const $24168bfc9e232f27$export$73cba17c10a00d41 = 410;
const $24168bfc9e232f27$export$bc275033437a2e03 = 429;
const $24168bfc9e232f27$export$80be1ba03533fcfc = 499;
const $24168bfc9e232f27$export$ec31e119ef282c60 = 500;
const $24168bfc9e232f27$export$310d0488bddd36e1 = 500;
const $24168bfc9e232f27$export$b18794ec8d78bd2f = 503;
const $24168bfc9e232f27$export$d53e5bd3ec9a0f2a = 504;
const $24168bfc9e232f27$export$cabebb7af2e4f2f0 = 599;
const $24168bfc9e232f27$export$910bb73d987bdc9 = 600;
const $24168bfc9e232f27$export$8343e6f32f5246de = {
    GET: "GET",
    POST: "POST"
};
const $24168bfc9e232f27$export$893b1b5b686d84ef = [
    $24168bfc9e232f27$export$74fa595b48c8c01e,
    $24168bfc9e232f27$export$76ff9ac69ea41312,
    $24168bfc9e232f27$export$b281676656f67eb4
];
const $24168bfc9e232f27$export$268e88275f5afab2 = [
    ...$24168bfc9e232f27$export$893b1b5b686d84ef,
    $24168bfc9e232f27$export$a69a793fa9a71a6f
];
/**
 * Request header names
 */ const $24168bfc9e232f27$export$28d77f87efed1d88 = {
    CONTENT_TYPE: "Content-Type",
    CONTENT_LENGTH: "Content-Length",
    RETRY_AFTER: "Retry-After",
    CCS_HEADER: "X-AnchorMailbox",
    WWWAuthenticate: "WWW-Authenticate",
    AuthenticationInfo: "Authentication-Info",
    X_MS_REQUEST_ID: "x-ms-request-id",
    X_MS_HTTP_VERSION: "x-ms-httpver"
};
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */ const $24168bfc9e232f27$export$81ab9ba9bd28255c = {
    ACTIVE_ACCOUNT_FILTERS: "active-account-filters"
};
/**
 * String constants related to AAD Authority
 */ const $24168bfc9e232f27$export$3fd50d6e6941567f = {
    COMMON: "common",
    ORGANIZATIONS: "organizations",
    CONSUMERS: "consumers"
};
/**
 * Claims request keys
 */ const $24168bfc9e232f27$export$c125cda26c71ef54 = {
    ACCESS_TOKEN: "access_token",
    XMS_CC: "xms_cc"
};
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */ const $24168bfc9e232f27$export$49a06cbda5acaa5 = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
    CREATE: "create",
    NO_SESSION: "no_session"
};
/**
 * allowed values for codeVerifier
 */ const $24168bfc9e232f27$export$a1fe36237c1cc863 = {
    PLAIN: "plain",
    S256: "S256"
};
/**
 * Allowed values for response_type
 */ const $24168bfc9e232f27$export$5ef2b2ebd3da3e04 = {
    CODE: "code",
    IDTOKEN_TOKEN: "id_token token",
    IDTOKEN_TOKEN_REFRESHTOKEN: "id_token token refresh_token"
};
/**
 * allowed values for response_mode
 */ const $24168bfc9e232f27$export$f990a5bae1260b8c = {
    QUERY: "query",
    FRAGMENT: "fragment",
    FORM_POST: "form_post"
};
/**
 * allowed grant_type
 */ const $24168bfc9e232f27$export$ce68f19b50b39c0b = {
    IMPLICIT_GRANT: "implicit",
    AUTHORIZATION_CODE_GRANT: "authorization_code",
    CLIENT_CREDENTIALS_GRANT: "client_credentials",
    RESOURCE_OWNER_PASSWORD_GRANT: "password",
    REFRESH_TOKEN_GRANT: "refresh_token",
    DEVICE_CODE_GRANT: "device_code",
    JWT_BEARER: "urn:ietf:params:oauth:grant-type:jwt-bearer"
};
/**
 * Account types in Cache
 */ const $24168bfc9e232f27$export$5a1fc3a8d23f6b21 = "MSSTS";
const $24168bfc9e232f27$export$8fb8b1752739f076 = "ADFS";
const $24168bfc9e232f27$export$9e5e568c23c195ce = "MSA";
const $24168bfc9e232f27$export$2825edabe103d5 = "Generic";
/**
 * Separators used in cache
 */ const $24168bfc9e232f27$export$9e9532f57bbb139e = "-";
const $24168bfc9e232f27$export$2e94b6c6dd44699e = ".";
/**
 * Credential Type stored in the cache
 */ const $24168bfc9e232f27$export$eca2dc7e6e608a68 = {
    ID_TOKEN: "IdToken",
    ACCESS_TOKEN: "AccessToken",
    ACCESS_TOKEN_WITH_AUTH_SCHEME: "AccessToken_With_AuthScheme",
    REFRESH_TOKEN: "RefreshToken"
};
/**
 * Combine all cache types
 */ const $24168bfc9e232f27$export$ba193b555633db78 = {
    ADFS: 1001,
    MSA: 1002,
    MSSTS: 1003,
    GENERIC: 1004,
    ACCESS_TOKEN: 2001,
    REFRESH_TOKEN: 2002,
    ID_TOKEN: 2003,
    APP_METADATA: 3001,
    UNDEFINED: 9999
};
/**
 * More Cache related constants
 */ const $24168bfc9e232f27$export$7e1bea6dc1b6b32e = "appmetadata";
const $24168bfc9e232f27$export$476989d62bcb4c85 = "client_info";
const $24168bfc9e232f27$export$978fe7ab5e74b539 = "1";
const $24168bfc9e232f27$export$1137b2d06fad26eb = "authority-metadata";
const $24168bfc9e232f27$export$eea04158dccf5d70 = 86400; // 24 Hours
const $24168bfc9e232f27$export$5d365d77acfcb55d = {
    CONFIG: "config",
    CACHE: "cache",
    NETWORK: "network",
    HARDCODED_VALUES: "hardcoded_values"
};
const $24168bfc9e232f27$export$ada8c967fb9297cd = 5;
const $24168bfc9e232f27$export$3ab7d699ccf481db = 80; // ESTS limit is 100B, set to 80 to provide a 20B buffer
const $24168bfc9e232f27$export$166696a6bac48dc5 = 330; // ESTS limit is 350B, set to 330 to provide a 20B buffer,
const $24168bfc9e232f27$export$6fa374559f78ca9f = 50; // Limit the number of errors that can be stored to prevent uncontrolled size gains
const $24168bfc9e232f27$export$788940e4cd6c0eba = "server-telemetry";
const $24168bfc9e232f27$export$f51f7d493a85471e = "|";
const $24168bfc9e232f27$export$b0781166f23da624 = ",";
const $24168bfc9e232f27$export$1ee554efbc503c65 = "1";
const $24168bfc9e232f27$export$aad3ca432a8e0485 = "0";
const $24168bfc9e232f27$export$b3ede2149169f35e = "unknown_error";
/**
 * Type of the authentication request
 */ const $24168bfc9e232f27$export$901491a717da2ba5 = {
    BEARER: "Bearer",
    POP: "pop",
    SSH: "ssh-cert"
};
/**
 * Constants related to throttling
 */ const $24168bfc9e232f27$export$c79860cd1fb326bc = 60;
// Default maximum time to throttle in seconds, overrides what the server sends back
const $24168bfc9e232f27$export$ed50f84f656b8a71 = 3600;
// Prefix for storing throttling entries
const $24168bfc9e232f27$export$2c4d2738c7e2e621 = "throttling";
// Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
const $24168bfc9e232f27$export$796cc5ec53357060 = "retry-after, h429";
/**
 * Errors
 */ const $24168bfc9e232f27$export$885686d5cda1602e = "invalid_grant";
const $24168bfc9e232f27$export$5c3e811110c23b4b = "client_mismatch";
/**
 * Password grant parameters
 */ const $24168bfc9e232f27$export$fa8b29062cab1da = {
    username: "username",
    password: "password"
};
/**
 * Region Discovery Sources
 */ const $24168bfc9e232f27$export$3d4a3e11df589b40 = {
    FAILED_AUTO_DETECTION: "1",
    INTERNAL_CACHE: "2",
    ENVIRONMENT_VARIABLE: "3",
    IMDS: "4"
};
/**
 * Region Discovery Outcomes
 */ const $24168bfc9e232f27$export$92a685f9218422bd = {
    CONFIGURED_MATCHES_DETECTED: "1",
    CONFIGURED_NO_AUTO_DETECTION: "2",
    CONFIGURED_NOT_DETECTED: "3",
    AUTO_DETECTION_REQUESTED_SUCCESSFUL: "4",
    AUTO_DETECTION_REQUESTED_FAILED: "5"
};
/**
 * Specifies the reason for fetching the access token from the identity provider
 */ const $24168bfc9e232f27$export$aa4af185ea049f6b = {
    // When a token is found in the cache or the cache is not supposed to be hit when making the request
    NOT_APPLICABLE: "0",
    // When the token request goes to the identity provider because force_refresh was set to true. Also occurs if claims were requested
    FORCE_REFRESH_OR_CLAIMS: "1",
    // When the token request goes to the identity provider because no cached access token exists
    NO_CACHED_ACCESS_TOKEN: "2",
    // When the token request goes to the identity provider because cached access token expired
    CACHED_ACCESS_TOKEN_EXPIRED: "3",
    // When the token request goes to the identity provider because refresh_in was used and the existing token needs to be refreshed
    PROACTIVELY_REFRESHED: "4"
};
const $24168bfc9e232f27$export$fe5c42ed17efe603 = {
    Jwt: "JWT",
    Jwk: "JWK",
    Pop: "pop"
};
const $24168bfc9e232f27$export$14c29d43b22a755f = 86400000;
// Token renewal offset default in seconds
const $24168bfc9e232f27$export$8d50f42618161d1a = 300;
const $24168bfc9e232f27$export$6592cb873eed5846 = {
    BASE64: "base64",
    HEX: "hex",
    UTF8: "utf-8"
};

});

parcelRegister("irvad", function(module, exports) {

$parcel$export(module.exports, "ClientAuthError", () => $985c5c593ada8e6e$export$a839ff85a7957561);
$parcel$export(module.exports, "createClientAuthError", () => $985c5c593ada8e6e$export$ea892ce48f5bb4f3);
/*! @azure/msal-common v16.5.2 2026-04-28 */ 
var $hNtj2 = parcelRequire("hNtj2");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ /**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $985c5c593ada8e6e$export$a839ff85a7957561 extends (0, $hNtj2.AuthError) {
    constructor(errorCode, additionalMessage){
        super(errorCode, additionalMessage);
        this.name = "ClientAuthError";
        Object.setPrototypeOf(this, $985c5c593ada8e6e$export$a839ff85a7957561.prototype);
    }
}
function $985c5c593ada8e6e$export$ea892ce48f5bb4f3(errorCode, additionalMessage) {
    return new $985c5c593ada8e6e$export$a839ff85a7957561(errorCode, additionalMessage);
}

});
parcelRegister("hNtj2", function(module, exports) {

$parcel$export(module.exports, "getDefaultErrorMessage", () => $c87ae953906cad7d$export$714f3eb4b9ca37c5);
$parcel$export(module.exports, "AuthError", () => $c87ae953906cad7d$export$145273558d58e0ac);
$parcel$export(module.exports, "createAuthError", () => $c87ae953906cad7d$export$eb157f7636c79bd2);
/*! @azure/msal-common v16.5.2 2026-04-28 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $c87ae953906cad7d$export$714f3eb4b9ca37c5(code) {
    return `See https://aka.ms/msal.js.errors#${code} for details`;
}
/**
 * General error class thrown by the MSAL.js library.
 */ class $c87ae953906cad7d$export$145273558d58e0ac extends Error {
    constructor(errorCode, errorMessage, suberror){
        const message = errorMessage || (errorCode ? $c87ae953906cad7d$export$714f3eb4b9ca37c5(errorCode) : "");
        const errorString = message ? `${errorCode}: ${message}` : errorCode;
        super(errorString);
        Object.setPrototypeOf(this, $c87ae953906cad7d$export$145273558d58e0ac.prototype);
        this.errorCode = errorCode || "";
        this.errorMessage = message || "";
        this.subError = suberror || "";
        this.name = "AuthError";
    }
    setCorrelationId(correlationId) {
        this.correlationId = correlationId;
    }
}
function $c87ae953906cad7d$export$eb157f7636c79bd2(code, additionalMessage) {
    return new $c87ae953906cad7d$export$145273558d58e0ac(code, additionalMessage || $c87ae953906cad7d$export$714f3eb4b9ca37c5(code));
}

});


parcelRegister("ks9Dx", function(module, exports) {

$parcel$export(module.exports, "clientInfoDecodingError", () => $1477605d975057f9$export$ccdf48c387c47b82);
$parcel$export(module.exports, "clientInfoEmptyError", () => $1477605d975057f9$export$12315251e24e0181);
$parcel$export(module.exports, "tokenParsingError", () => $1477605d975057f9$export$ad362b2e3a260143);
$parcel$export(module.exports, "nullOrEmptyToken", () => $1477605d975057f9$export$78d01e29cb494be2);
$parcel$export(module.exports, "endpointResolutionError", () => $1477605d975057f9$export$c9fcc93738cc2bc3);
$parcel$export(module.exports, "networkError", () => $1477605d975057f9$export$4358cbadf08aa73);
$parcel$export(module.exports, "openIdConfigError", () => $1477605d975057f9$export$73566da29bc073eb);
$parcel$export(module.exports, "hashNotDeserialized", () => $1477605d975057f9$export$14c4d54a8414667f);
$parcel$export(module.exports, "invalidState", () => $1477605d975057f9$export$72a77317632c052b);
$parcel$export(module.exports, "stateMismatch", () => $1477605d975057f9$export$6a56d8f882843cd8);
$parcel$export(module.exports, "stateNotFound", () => $1477605d975057f9$export$ef9214cfa5960fc);
$parcel$export(module.exports, "nonceMismatch", () => $1477605d975057f9$export$edd0491c2c280be7);
$parcel$export(module.exports, "authTimeNotFound", () => $1477605d975057f9$export$43356944266c945e);
$parcel$export(module.exports, "maxAgeTranspired", () => $1477605d975057f9$export$f95fb86904f89749);
$parcel$export(module.exports, "multipleMatchingTokens", () => $1477605d975057f9$export$47c50a2451614107);
$parcel$export(module.exports, "multipleMatchingAppMetadata", () => $1477605d975057f9$export$575bb2924bcd0084);
$parcel$export(module.exports, "requestCannotBeMade", () => $1477605d975057f9$export$4ac9fb1f531eded7);
$parcel$export(module.exports, "cannotRemoveEmptyScope", () => $1477605d975057f9$export$f7a276c01beb068a);
$parcel$export(module.exports, "cannotAppendScopeSet", () => $1477605d975057f9$export$93883786cf4a4a27);
$parcel$export(module.exports, "emptyInputScopeSet", () => $1477605d975057f9$export$41e2ce5958c42c83);
$parcel$export(module.exports, "noAccountInSilentRequest", () => $1477605d975057f9$export$5a3c7d1c90ac9220);
$parcel$export(module.exports, "invalidCacheRecord", () => $1477605d975057f9$export$d396103576f879cc);
$parcel$export(module.exports, "invalidCacheEnvironment", () => $1477605d975057f9$export$dedc648643245fa1);
$parcel$export(module.exports, "noAccountFound", () => $1477605d975057f9$export$b98ebfe073f0162f);
$parcel$export(module.exports, "noCryptoObject", () => $1477605d975057f9$export$c39e501a22cba395);
$parcel$export(module.exports, "unexpectedCredentialType", () => $1477605d975057f9$export$21fdd1f95350cd6d);
$parcel$export(module.exports, "tokenRefreshRequired", () => $1477605d975057f9$export$e23b692cce0c7779);
$parcel$export(module.exports, "tokenClaimsCnfRequiredForSignedJwt", () => $1477605d975057f9$export$6f89b8a7d491b526);
$parcel$export(module.exports, "authorizationCodeMissingFromServerResponse", () => $1477605d975057f9$export$93625fc864d26bba);
$parcel$export(module.exports, "bindingKeyNotRemoved", () => $1477605d975057f9$export$5765db5d84418d29);
$parcel$export(module.exports, "endSessionEndpointNotSupported", () => $1477605d975057f9$export$c3bd741c16a889f3);
$parcel$export(module.exports, "keyIdMissing", () => $1477605d975057f9$export$3c9338a50e294d1);
$parcel$export(module.exports, "noNetworkConnectivity", () => $1477605d975057f9$export$31ae862f18c3b2b7);
$parcel$export(module.exports, "userCanceled", () => $1477605d975057f9$export$8ee329e65a880ec7);
$parcel$export(module.exports, "methodNotImplemented", () => $1477605d975057f9$export$24176fc1f15eea22);
$parcel$export(module.exports, "nestedAppAuthBridgeDisabled", () => $1477605d975057f9$export$3078b0202fe7eea3);
$parcel$export(module.exports, "platformBrokerError", () => $1477605d975057f9$export$3642667d172bf3ce);
$parcel$export(module.exports, "resourceParameterRequired", () => $1477605d975057f9$export$17a59a33a4e9e5f7);
$parcel$export(module.exports, "misplacedResourceParam", () => $1477605d975057f9$export$b4ecff4fd4f67ea0);
/*! @azure/msal-common v16.5.2 2026-04-28 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $1477605d975057f9$export$ccdf48c387c47b82 = "client_info_decoding_error";
const $1477605d975057f9$export$12315251e24e0181 = "client_info_empty_error";
const $1477605d975057f9$export$ad362b2e3a260143 = "token_parsing_error";
const $1477605d975057f9$export$78d01e29cb494be2 = "null_or_empty_token";
const $1477605d975057f9$export$c9fcc93738cc2bc3 = "endpoints_resolution_error";
const $1477605d975057f9$export$4358cbadf08aa73 = "network_error";
const $1477605d975057f9$export$73566da29bc073eb = "openid_config_error";
const $1477605d975057f9$export$14c4d54a8414667f = "hash_not_deserialized";
const $1477605d975057f9$export$72a77317632c052b = "invalid_state";
const $1477605d975057f9$export$6a56d8f882843cd8 = "state_mismatch";
const $1477605d975057f9$export$ef9214cfa5960fc = "state_not_found";
const $1477605d975057f9$export$edd0491c2c280be7 = "nonce_mismatch";
const $1477605d975057f9$export$43356944266c945e = "auth_time_not_found";
const $1477605d975057f9$export$f95fb86904f89749 = "max_age_transpired";
const $1477605d975057f9$export$47c50a2451614107 = "multiple_matching_tokens";
const $1477605d975057f9$export$575bb2924bcd0084 = "multiple_matching_appMetadata";
const $1477605d975057f9$export$4ac9fb1f531eded7 = "request_cannot_be_made";
const $1477605d975057f9$export$f7a276c01beb068a = "cannot_remove_empty_scope";
const $1477605d975057f9$export$93883786cf4a4a27 = "cannot_append_scopeset";
const $1477605d975057f9$export$41e2ce5958c42c83 = "empty_input_scopeset";
const $1477605d975057f9$export$5a3c7d1c90ac9220 = "no_account_in_silent_request";
const $1477605d975057f9$export$d396103576f879cc = "invalid_cache_record";
const $1477605d975057f9$export$dedc648643245fa1 = "invalid_cache_environment";
const $1477605d975057f9$export$b98ebfe073f0162f = "no_account_found";
const $1477605d975057f9$export$c39e501a22cba395 = "no_crypto_object";
const $1477605d975057f9$export$21fdd1f95350cd6d = "unexpected_credential_type";
const $1477605d975057f9$export$e23b692cce0c7779 = "token_refresh_required";
const $1477605d975057f9$export$6f89b8a7d491b526 = "token_claims_cnf_required_for_signedjwt";
const $1477605d975057f9$export$93625fc864d26bba = "authorization_code_missing_from_server_response";
const $1477605d975057f9$export$5765db5d84418d29 = "binding_key_not_removed";
const $1477605d975057f9$export$c3bd741c16a889f3 = "end_session_endpoint_not_supported";
const $1477605d975057f9$export$3c9338a50e294d1 = "key_id_missing";
const $1477605d975057f9$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $1477605d975057f9$export$8ee329e65a880ec7 = "user_canceled";
const $1477605d975057f9$export$24176fc1f15eea22 = "method_not_implemented";
const $1477605d975057f9$export$3078b0202fe7eea3 = "nested_app_auth_bridge_disabled";
const $1477605d975057f9$export$3642667d172bf3ce = "platform_broker_error";
const $1477605d975057f9$export$17a59a33a4e9e5f7 = "resource_parameter_required";
const $1477605d975057f9$export$b4ecff4fd4f67ea0 = "misplaced_resource_parameter";

});


parcelRegister("fYaFh", function(module, exports) {

$parcel$export(module.exports, "UrlString", () => $021dfbaf1baf19ed$export$3abcdca7229e54f2);
/*! @azure/msal-common v16.5.2 2026-04-28 */ 
var $9wut7 = parcelRequire("9wut7");

var $8rx4G = parcelRequire("8rx4G");

var $9C5X5 = parcelRequire("9C5X5");

var $gw4YQ = parcelRequire("gw4YQ");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Url object class which can perform various transformations on url strings.
 */ class $021dfbaf1baf19ed$export$3abcdca7229e54f2 {
    get urlString() {
        return this._urlString;
    }
    constructor(url){
        this._urlString = url;
        if (!this._urlString) // Throws error if url is empty
        throw (0, $9wut7.createClientConfigurationError)((0, $gw4YQ.urlEmptyError));
        if (!url.includes("#")) this._urlString = $021dfbaf1baf19ed$export$3abcdca7229e54f2.canonicalizeUri(url);
    }
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */ static canonicalizeUri(url) {
        if (url) {
            let lowerCaseUrl = url.toLowerCase();
            if ((0, $8rx4G.StringUtils).endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            else if ((0, $8rx4G.StringUtils).endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            if (!(0, $8rx4G.StringUtils).endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
            return lowerCaseUrl;
        }
        return url;
    }
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */ validateAsUri() {
        // Attempts to parse url for uri components
        let components;
        try {
            components = this.getUrlComponents();
        } catch (e) {
            throw (0, $9wut7.createClientConfigurationError)((0, $gw4YQ.urlParseError));
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) throw (0, $9wut7.createClientConfigurationError)((0, $gw4YQ.urlParseError));
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") throw (0, $9wut7.createClientConfigurationError)((0, $gw4YQ.authorityUriInsecure));
    }
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */ static appendQueryString(url, queryString) {
        if (!queryString) return url;
        return url.indexOf("?") < 0 ? `${url}?${queryString}` : `${url}&${queryString}`;
    }
    /**
     * Returns a url with the hash removed
     * @param url
     */ static removeHashFromUrl(url) {
        return $021dfbaf1baf19ed$export$3abcdca7229e54f2.canonicalizeUri(url.split("#")[0]);
    }
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */ replaceTenantPath(tenantId) {
        const urlObject = this.getUrlComponents();
        const pathArray = urlObject.PathSegments;
        if (tenantId && pathArray.length !== 0 && (pathArray[0] === (0, $9C5X5.AADAuthority).COMMON || pathArray[0] === (0, $9C5X5.AADAuthority).ORGANIZATIONS)) pathArray[0] = tenantId;
        return $021dfbaf1baf19ed$export$3abcdca7229e54f2.constructAuthorityUriFromObject(urlObject);
    }
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */ getUrlComponents() {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        const regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        const match = this.urlString.match(regEx);
        if (!match) throw (0, $9wut7.createClientConfigurationError)((0, $gw4YQ.urlParseError));
        // Url component object
        const urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        let pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter((val)=>val && val.length > 0); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (urlComponents.QueryString && urlComponents.QueryString.endsWith("/")) urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        return urlComponents;
    }
    static getDomainFromUrl(url) {
        const regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        const match = url.match(regEx);
        if (!match) throw (0, $9wut7.createClientConfigurationError)((0, $gw4YQ.urlParseError));
        return match[2];
    }
    static getAbsoluteUrl(relativeUrl, baseUrl) {
        if (relativeUrl[0] === (0, $9C5X5.FORWARD_SLASH)) {
            const url = new $021dfbaf1baf19ed$export$3abcdca7229e54f2(baseUrl);
            const baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    }
    static constructAuthorityUriFromObject(urlObject) {
        return new $021dfbaf1baf19ed$export$3abcdca7229e54f2(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"));
    }
}

});
parcelRegister("9wut7", function(module, exports) {

$parcel$export(module.exports, "ClientConfigurationError", () => $d8394bf608809770$export$ac9d9d20c2327339);
$parcel$export(module.exports, "createClientConfigurationError", () => $d8394bf608809770$export$5d63d098f4f130a1);
/*! @azure/msal-common v16.5.2 2026-04-28 */ 
var $hNtj2 = parcelRequire("hNtj2");
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */ class $d8394bf608809770$export$ac9d9d20c2327339 extends (0, $hNtj2.AuthError) {
    constructor(errorCode){
        super(errorCode);
        this.name = "ClientConfigurationError";
        Object.setPrototypeOf(this, $d8394bf608809770$export$ac9d9d20c2327339.prototype);
    }
}
function $d8394bf608809770$export$5d63d098f4f130a1(errorCode) {
    return new $d8394bf608809770$export$ac9d9d20c2327339(errorCode);
}

});

parcelRegister("8rx4G", function(module, exports) {

$parcel$export(module.exports, "StringUtils", () => $dc1087b31e7dec9e$export$ecc754f99843e759);
/*! @azure/msal-common v16.5.2 2026-04-28 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @hidden
 */ class $dc1087b31e7dec9e$export$ecc754f99843e759 {
    /**
     * Check if stringified object is empty
     * @param strObj
     */ static isEmptyObj(strObj) {
        if (strObj) try {
            const obj = JSON.parse(strObj);
            return Object.keys(obj).length === 0;
        } catch (e) {}
        return true;
    }
    static startsWith(str, search) {
        return str.indexOf(search) === 0;
    }
    static endsWith(str, search) {
        return str.length >= search.length && str.lastIndexOf(search) === str.length - search.length;
    }
    /**
     * Parses string into an object.
     *
     * @param query
     */ static queryStringToObject(query) {
        const obj = {};
        const params = query.split("&");
        const decode = (s)=>decodeURIComponent(s.replace(/\+/g, " "));
        params.forEach((pair)=>{
            if (pair.trim()) {
                const [key, value] = pair.split(/=(.+)/g, 2); // Split on the first occurence of the '=' character
                if (key && value) obj[decode(key)] = decode(value);
            }
        });
        return obj;
    }
    /**
     * Trims entries in an array.
     *
     * @param arr
     */ static trimArrayEntries(arr) {
        return arr.map((entry)=>entry.trim());
    }
    /**
     * Removes empty strings from array
     * @param arr
     */ static removeEmptyStringsFromArray(arr) {
        return arr.filter((entry)=>{
            return !!entry;
        });
    }
    /**
     * Attempts to parse a string into JSON
     * @param str
     */ static jsonParseHelper(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }
}

});

parcelRegister("gw4YQ", function(module, exports) {

$parcel$export(module.exports, "redirectUriEmpty", () => $fe66171f49c2124f$export$7a02f9bdce79dd4e);
$parcel$export(module.exports, "claimsRequestParsingError", () => $fe66171f49c2124f$export$561c97672a478709);
$parcel$export(module.exports, "authorityUriInsecure", () => $fe66171f49c2124f$export$f77c6af656c8444b);
$parcel$export(module.exports, "urlParseError", () => $fe66171f49c2124f$export$ee2a1a3389f75508);
$parcel$export(module.exports, "urlEmptyError", () => $fe66171f49c2124f$export$859df485a5e0f239);
$parcel$export(module.exports, "emptyInputScopesError", () => $fe66171f49c2124f$export$6ac27379c42383f);
$parcel$export(module.exports, "invalidClaims", () => $fe66171f49c2124f$export$96e755c70e0d0e34);
$parcel$export(module.exports, "tokenRequestEmpty", () => $fe66171f49c2124f$export$eca67ff7a91fed9d);
$parcel$export(module.exports, "logoutRequestEmpty", () => $fe66171f49c2124f$export$9eb2eeb401492d88);
$parcel$export(module.exports, "invalidCodeChallengeMethod", () => $fe66171f49c2124f$export$b8d8b332f17376dc);
$parcel$export(module.exports, "pkceParamsMissing", () => $fe66171f49c2124f$export$2da3866b327f1753);
$parcel$export(module.exports, "invalidCloudDiscoveryMetadata", () => $fe66171f49c2124f$export$92a2985751150ca5);
$parcel$export(module.exports, "invalidAuthorityMetadata", () => $fe66171f49c2124f$export$edb4d5942bc8ccff);
$parcel$export(module.exports, "untrustedAuthority", () => $fe66171f49c2124f$export$50c3162fda5f57);
$parcel$export(module.exports, "missingSshJwk", () => $fe66171f49c2124f$export$8fbed44b22d9136f);
$parcel$export(module.exports, "missingSshKid", () => $fe66171f49c2124f$export$b728bd8a588956c);
$parcel$export(module.exports, "missingNonceAuthenticationHeader", () => $fe66171f49c2124f$export$4f88b4462bcef15f);
$parcel$export(module.exports, "invalidAuthenticationHeader", () => $fe66171f49c2124f$export$bea58e1a2e503b59);
$parcel$export(module.exports, "cannotSetOIDCOptions", () => $fe66171f49c2124f$export$a5c9fbb90473dca2);
$parcel$export(module.exports, "cannotAllowPlatformBroker", () => $fe66171f49c2124f$export$9a3a7609ff879ac7);
$parcel$export(module.exports, "authorityMismatch", () => $fe66171f49c2124f$export$91415fb6baea5d09);
$parcel$export(module.exports, "invalidRequestMethodForEAR", () => $fe66171f49c2124f$export$370f4bd236cb2302);
/*! @azure/msal-common v16.5.2 2026-04-28 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $fe66171f49c2124f$export$7a02f9bdce79dd4e = "redirect_uri_empty";
const $fe66171f49c2124f$export$561c97672a478709 = "claims_request_parsing_error";
const $fe66171f49c2124f$export$f77c6af656c8444b = "authority_uri_insecure";
const $fe66171f49c2124f$export$ee2a1a3389f75508 = "url_parse_error";
const $fe66171f49c2124f$export$859df485a5e0f239 = "empty_url_error";
const $fe66171f49c2124f$export$6ac27379c42383f = "empty_input_scopes_error";
const $fe66171f49c2124f$export$96e755c70e0d0e34 = "invalid_claims";
const $fe66171f49c2124f$export$eca67ff7a91fed9d = "token_request_empty";
const $fe66171f49c2124f$export$9eb2eeb401492d88 = "logout_request_empty";
const $fe66171f49c2124f$export$b8d8b332f17376dc = "invalid_code_challenge_method";
const $fe66171f49c2124f$export$2da3866b327f1753 = "pkce_params_missing";
const $fe66171f49c2124f$export$92a2985751150ca5 = "invalid_cloud_discovery_metadata";
const $fe66171f49c2124f$export$edb4d5942bc8ccff = "invalid_authority_metadata";
const $fe66171f49c2124f$export$50c3162fda5f57 = "untrusted_authority";
const $fe66171f49c2124f$export$8fbed44b22d9136f = "missing_ssh_jwk";
const $fe66171f49c2124f$export$b728bd8a588956c = "missing_ssh_kid";
const $fe66171f49c2124f$export$4f88b4462bcef15f = "missing_nonce_authentication_header";
const $fe66171f49c2124f$export$bea58e1a2e503b59 = "invalid_authentication_header";
const $fe66171f49c2124f$export$a5c9fbb90473dca2 = "cannot_set_OIDCOptions";
const $fe66171f49c2124f$export$9a3a7609ff879ac7 = "cannot_allow_platform_broker";
const $fe66171f49c2124f$export$91415fb6baea5d09 = "authority_mismatch";
const $fe66171f49c2124f$export$370f4bd236cb2302 = "invalid_request_method_for_EAR";

});



//# sourceMappingURL=blank.5c27f0e6.js.map
